import type { PortfolioPosition } from '../portfolio/models/PortfolioPosition';
import type { CustomReminder } from '../calendar/models';
import type { WatchlistItem } from '../watchlist/models/WatchlistItem';
import type { ProfitLabScenario } from '../profit-lab/profitLab.types';

export const DATA_EXPORT_FORMAT_VERSION = '1.0.0';
export const VALEMATO_APP_VERSION = '0.5.44-alpha.1';
export type ExportDataset = 'portfolioPositions' | 'portfolioSales' | 'portfolioListings' | 'portfolioTransferStatuses' | 'portfolioTimeline' | 'tradingJournal' | 'decisionJournal' | 'watchlistItems' | 'calendarReminders' | 'profitLabScenarios';

export interface DataExportMetadata {
  formatVersion: string;
  appVersion: string;
  createdAt: string;
  locale: string;
  includedDatasets: ExportDataset[];
  portfolioSchemaVersion: number | null;
}

export interface CompleteDataExport {
  metadata: DataExportMetadata;
  portfolio: { positions: PortfolioPosition[] };
  watchlist: { items: WatchlistItem[] };
  calendar?: { reminders: CustomReminder[] };
  profitLab?: { scenarios: ProfitLabScenario[] };
}
